const prefix = 'ADC_PINCODE/';
export const GET_INIT_ADC_DATA = `${prefix}GET_INIT_ADC_DATA`;
export const SET_INIT_ADC_DATA = `${prefix}SET_INIT_ADC_DATA`;
export const SET_ADC_LOADING = `${prefix}SET_ADC_LOADING`;

export const getInitAdcData = data => ({ type: GET_INIT_ADC_DATA, data });

export const setAdcLoading = () => ({ type: SET_ADC_LOADING });
